module.exports = __webpack_public_path__ + "img/marshalling.2f390b28.png";